export default __webpack_public_path__ + "static/oneep-7c39f79f75cc5bcd0a9c4247f390dfca.png";